module.exports = __webpack_public_path__ + "img/green-circle.89afc55a.svg";